import { Navigate, Route, Routes } from 'react-router-dom';
import { HistoryRouter } from 'redux-first-history/rr6';

import Groups from '../../components/Groups';
import Permissions from '../../components/Permissions';
import UserList from '../../components/users/list/UserList';
import WelcomePage from '../../components/WelcomePage';
import { history } from '../store';

export function AppIndexRouter() {
    return (
        <HistoryRouter history={history}>
            <Routes>
                <Route path="/welcome" element={<WelcomePage />} />
                <Route path="/users" element={<UserList />} />
                <Route path="/groups" element={<Groups />} />
                <Route path="/permissions" element={<Permissions />} />
                <Route path="*" element={<Navigate to="/users" replace />} />
            </Routes>
        </HistoryRouter>
    );
}

export default AppIndexRouter;
